//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

export const PROMOTED_POSTS_METRICS_ACTIONS = {
    // Setup
  FETCH_ONBOARDING_STEPS_STATE: 'FETCH_ONBOARDING_STEPS_STATE',
  RECEIVE_ONBOARDING_STEPS_STATE_SUCCEEDED: 'RECEIVE_ONBOARDING_STEPS_STATE_SUCCEEDED',
  RECEIVE_ONBOARDING_STEPS_STATE_FAILED: 'RECEIVE_ONBOARDING_STEPS_STATE_FAILED',
  FETCH_GA_STATE: 'FETCH_GA_STATE',
  RECEIVE_GA_STATE: 'RECEIVE_GA_STATE',
  CHANGE_DATE_RANGE: 'CHANGE_DATE_RANGE',
  REQUEST_SUMMARY_STATS: 'REQUEST_SUMMARY_STATS',
  RECEIVE_AGGREGATE_STATS: 'RECEIVE_AGGREGATE_STATS',
  RECEIVE_TREND_STATS: 'RECEIVE_TREND_STATS',
  CHANGE_TRENDS_SELECTED_VALUE: 'CHANGE_TRENDS_SELECTED_VALUE',
  FETCH_PROMOTED_POSTS: 'FETCH_PROMOTED_POSTS',
  RECEIVE_PROMOTED_POSTS: 'RECEIVE_PROMOTED_POSTS',
  RECEIVE_PROMOTED_POSTS_SUCCEEDED: 'RECEIVE_PROMOTED_POSTS_SUCCEEDED',
  RECEIVE_PROMOTED_POSTS_FAILED: 'RECEIVE_PROMOTED_POSTS_FAILED',
  FETCH_RECENT_PROMOTED_POSTS: 'FETCH_RECENT_PROMOTED_POSTS',
  RECEIVE_RECENT_PROMOTED_POSTS_SUCCEEDED: 'RECEIVE_RECENT_PROMOTED_POSTS_SUCCEEDED',
  RECEIVE_RECENT_PROMOTED_POSTS_FAILED: 'RECEIVE_RECENT_PROMOTED_POSTS_FAILED',
  CHANGE_PROMOTED_POSTS_TABLE_PARAMS: 'CHANGE_PROMOTED_POSTS_TABLE_PARAMS',
  UPDATE_PROMOTION_STATUS: 'UPDATE_PROMOTION_STATUS',
  PAUSE_PROMOTION: 'PAUSE_PROMOTION',
  RESUME_PROMOTION: 'RESUME_PROMOTION',
  DELETE_PROMOTION: 'DELETE_PROMOTION',
  UPDATE_INSIGHTS_FOR_POST: 'UPDATE_INSIGHTS_FOR_POST',
  UPDATE_RUNNING_PROMOTION_POST_IDS: 'UPDATE_RUNNING_PROMOTION_POST_IDS',
  UPDATE_POST_PROMOTION_STATES: 'UPDATE_POST_PROMOTION_STATES',
  REQUEST_CURRENTLY_RUNNING: 'REQUEST_CURRENTLY_RUNNING',
  UPDATE_GA_ECOMMERCE_CONNECTED: 'UPDATE_GA_ECOMMERCE_CONNECTED',
};

export enum PromotedPostsMetricsStatuses {
    RUNNING = 'running',
    PENDING = 'pending',
    PAUSED = 'paused',
    ENDED = 'ended',
    DELETED = 'deleted',
    ERROR = 'error',
}

export const PROMOTED_POSTS_METRICS_ROUTES = {
  METRICS: 'instagramAccount.promotedPostMetrics',
} as const;
